import { useMemo, useEffect } from 'react';
import debounce from 'lodash.debounce';
import { Stack } from '@mui/material';

import { TopFilterForm } from 'app-zephyr-forms';
import { UPDATE_NAME_DELAY } from 'app-zephyr-constants';

export function TopFilter({
  name,
  filterIsChanged,
  placeholder,
}: {
  name: string | undefined;
  filterIsChanged: (value: string) => void;
  placeholder: string;
}) {
  const searchValueChanged = useMemo(() => debounce(filterIsChanged, UPDATE_NAME_DELAY), [filterIsChanged]);

  useEffect(() => {
    return () => {
      searchValueChanged.cancel();
    };
  }, [searchValueChanged]);

  const handleSearchChange = (val: string) => {
    searchValueChanged(val);
  };

  return (
    <Stack marginBottom={'16px'}>
      <TopFilterForm name={name ?? ''} type="rounded" onChange={handleSearchChange} placeholder={placeholder} />
    </Stack>
  );
}
